<template>
    <div class="comm_head">
        <img class="comm_head_title" @click="handleRouterSkip('Home')" :src="logoUrl" alt="">
        <ul class="comm_head_menus" v-show="$i18n.locale=='zh'">
            <li>
                <router-link to="/" :class="{'active_weight':$route.name=='Home'}">首页</router-link>
            </li>
            <li @click="setProfileChild(true)" @mouseenter="setProfileChild(true)" @mouseleave="setProfileChild(false)">
                <router-link :to="{ name: 'Profile'}" :class="{'active_background':ProfileChild,'active_weight':$route.name=='Profile'||$route.name=='Contact'}">公司简介</router-link>
                <div class="menus_child_item" :class="{'active_background':ProfileChild}" v-show="ProfileChild">
                    <router-link to="/Profile" :class="{'active_color':$route.name=='Profile'}">公司介绍</router-link>
                    <router-link to="/Contact" :class="{'active_color':$route.name=='Contact'}">联系我们</router-link>
                </div>
            </li>
            <li @click="setDynamicChild(true)" @mouseenter="setDynamicChild(true)" @mouseleave="setDynamicChild(false)">
                <router-link :to="{ name: 'List', query: {cat:1}}" :class="{'active_background':DynamicChild,'active_weight':$route.name=='List' && ($route.query.cat==1||$route.query.cat==2)}">公司动态</router-link>
                <div class="menus_child_item" :class="{'active_background':DynamicChild}" v-show="DynamicChild">
                    <router-link :to="{ name: 'List', query: {cat:1}}" :class="{'active_color':$route.name=='List' && $route.query.cat==1 }">公司新闻</router-link>
                    <router-link :to="{ name: 'List', query: {cat:2}}" :class="{'active_color':$route.name=='List' && $route.query.cat==2 }">员工天地</router-link>
                </div>
            </li>
            <li>
                <router-link to="/Join" :class="{'active_weight':$route.name=='Join'}">加入我们</router-link>
            </li>
            <li @click="setMailehuiChild(true)" @mouseenter="setMailehuiChild(true)" @mouseleave="setMailehuiChild(false)">
                <router-link to="/Mailehui" :class="{'active_background':MailehuiChild,'active_weight':$route.name=='Mailehui' || ($route.name=='List' && ($route.query.cat==3||$route.query.cat==4))}">麦乐会</router-link>
                <div class="menus_child_item" :class="{'active_background':MailehuiChild}" v-show="MailehuiChild">
                    <router-link to="/Mailehui" :class="{'active_color':$route.name=='Mailehui'}">麦乐会介绍</router-link>
                    <router-link :to="{ name: 'List', query: {cat:3}}" :class="{'active_color':$route.name=='List' && $route.query.cat==3 }">人人有爱</router-link>
                    <router-link :to="{ name: 'List', query: {cat:4}}" :class="{'active_color':$route.name=='List' && $route.query.cat==4 }">公益助学</router-link>
                </div>
            </li>
            <li @click="setMaixueyuanChild(true)" @mouseenter="setMaixueyuanChild(true)" @mouseleave="setMaixueyuanChild(false)">
                <router-link to="/Maixueyuan" :class="{'active_background':MaixueyuanChild,'active_weight':$route.name=='Maixueyuan'||($route.name=='List' && $route.query.cat==5 )}">麦学园</router-link>
                <div class="menus_child_item" :class="{'active_background':MaixueyuanChild}" v-show="MaixueyuanChild">
                    <router-link to="/Maixueyuan" :class="{'active_color':$route.name=='Maixueyuan'}">麦学园介绍</router-link>
                    <router-link :to="{ name: 'List', query: {cat:5}}" :class="{'active_color':$route.name=='List' && $route.query.cat==5 }">学习园地</router-link>
                </div>
            </li>
        </ul>
        <div class="change_languge" @click="handleLanguageChange">
            {{$i18n.locale=='en'?'中文':'EN'}}
        </div>
    </div>
</template>
<script>
import { store, mutations } from '@/store'
const logoEn = require('../assets/images/duomai_logo_en.png')
const logoZh = require('../assets/images/duomai_logo.png')

export default {
    data() {
        return {
            locale: '',
            hideMenu: false,
            active: null,
            activeChild: null,
            logoUrl: ''
        }
    },
    computed: {
        ProfileChild() {
            return store.ProfileChild
        },
        DynamicChild() {
            return store.DynamicChild
        },
        MailehuiChild() {
            return store.MailehuiChild
        },
        MaixueyuanChild() {
            return store.MaixueyuanChild
        },
        local() {
            return this.$i18n.locale
        }
    },
    watch: {
        'local'() {
            if (this.$i18n.locale == 'en') {
                this.$router.push({ name: 'Home' })
            }
        },
    },
    created() {
        this.$i18n.locale = localStorage.getItem('locale') || 'zh',
        this.logoUrl = this.$i18n.locale == 'en' ? logoEn : logoZh
    },
    methods: {
        handleRouterSkip(name) {
            this.$router.push({ name })
        },
        setProfileChild: mutations.setProfileChild,
        setDynamicChild: mutations.setDynamicChild,
        setMailehuiChild: mutations.setMailehuiChild,
        setMaixueyuanChild: mutations.setMaixueyuanChild,
        handleLanguageChange() {
            this.$i18n.locale = this.$i18n.locale == 'en' ? 'zh' : 'en'
            localStorage.setItem('locale', this.$i18n.locale)
            this.logoUrl = this.$i18n.locale == 'en' ? logoEn : logoZh
        }
    }
}
</script>

<style lang="scss" scoped>
.active_background {
    background-color: rgba(0, 0, 0, 0.8);
}
.active_weight {
    font-weight: bold;
}

.active_color {
    color: #ff9200 !important;
}
.comm_head {
    width: 1200px;
    height: 88px;
    display: flex;
    justify-content: space-between;
    margin: 0 auto;
    color: #fff;
    z-index: 1000;
    align-items: center;
    & .comm_head_title {
        width: 150px;
        height: 52px;
        z-index: 1000;
    }
    & .comm_head_menus {
        height: 88px;
        flex: 1;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        & li {
            position: relative;
            cursor: pointer;
            z-index: 1000;
            & > a {
                display: block;
                height: 88px;
                width: 110px;
                text-align: center;
                line-height: 88px;
                font-size: 16px;
                color: #ffffff;
                margin-bottom: 1px;
            }
            & > a:hover {
                font-weight: bold;
            }
            & .menus_child_item {
                width: 110px;
                position: absolute;
                & > a {
                    display: block;
                    width: 110px;
                    height: 40px;
                    text-align: center;
                    line-height: 40px;
                    font-size: 16px;
                    color: #ffffff;
                    letter-spacing: 0;
                }
                & > a:hover {
                    color: #ff9200;
                }
            }
        }
        & li:nth-child(1) > a:hover,
        & li:nth-child(4) > a:hover {
            background-color: rgba(0, 0, 0, 0.8);
        }
    }
    & .change_languge {
        width: 60px;
        height: 26px;
        text-align: center;
        line-height: 26px;
        font-size: 14px;
        border: 1px solid #fff;
        border-radius: 13px;
        z-index: 1000;
        box-sizing: border-box;
        margin-left: 10px;
        cursor: pointer;
    }
    & .change_languge:hover {
        background: #ff9200;
        border: 1px solid #ff9200;
    }
}
</style>